import SearchIcon from "@mui/icons-material/Search";
import { useState } from "react";
import { Box, IconButton, InputAdornment, TextField } from "../../components";
import { SEARCH_DELAY } from "../../consts";

export const SearchBar = (props: {
  onStoppedTyping: (searchString: string) => void;
  setSearchFocused?: (value: boolean) => void;
  typeDelay?: boolean;
  size?: "small" | "medium" | undefined;
}) => {
  const typeDelay = props.typeDelay ?? true;
  const INITIAL_WIDTH: string = "300px";
  const EXPANDED_WIDTH: string = "300px";

  const [searchString, setSearchString] = useState<string>();
  const [typeDelayTimeoutId, setTypeDelayTimeoutId] = useState<any>();
  const [focused, setFocused] = useState<boolean>(false);
  const [show, setShow] = useState(false);

  function handleChange(e: any) {
    setSearchString(e.target.value);

    clearTimeout(typeDelayTimeoutId);
    const _typeDelayTimeoutId = setTimeout(
      function () {
        props.onStoppedTyping(e.target.value);
      },
      typeDelay ? SEARCH_DELAY : 0
    ); // wait for user to finish typing input: how many ms to wait
    setTypeDelayTimeoutId(_typeDelayTimeoutId);
  }

  function keyPress(e: any) {
    if (e.keyCode == 13) {
      // on ENTER
      props.onStoppedTyping(e.target.value);
      setTypeDelayTimeoutId(typeDelayTimeoutId);

      // put the login here
    }
  }

  return (
    <>
      {!show && (
        <Box>
          <IconButton onClick={() => setShow(true)}>
            <SearchIcon />
          </IconButton>
        </Box>
      )}

      {show && (
        <TextField
          autoFocus
          value={searchString}
          sx={{
            width: focused ? EXPANDED_WIDTH : INITIAL_WIDTH,
            transition: "width 300ms",
          }}
          onFocus={() => {
            setFocused(true);
            if (props.setSearchFocused) props.setSearchFocused(true);
          }}
          onBlur={() => {
            setFocused(false);

            if (!searchString) setShow(false);
            if (props.setSearchFocused) props.setSearchFocused(false);
          }}
          onChange={(e) => handleChange(e)}
          onKeyDown={(e) => keyPress(e)}
          placeholder={"Search"}
          //fullWidth
          autoComplete="off"
          size={props.size ? props.size : "medium"}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ opacity: "0.6" }}></SearchIcon>
              </InputAdornment>
            ),
          }}
        />
      )}
    </>
  );
};
